<template>
  <div v-if="topics.length" class="select-none">
    <div class="text-14 font-600 text-#999 mb-10 mt-7 text-center">
      {{ t("message.ai.newTopic") }}
    </div>
    <ul class="flex flex-col gap-10" v-if="topics.every(Boolean)">
      <li v-for="(item, index) in topics" :key="index">
        <div
          class="rounded-8 p-9 inline-block"
          style="box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.05)"
        >
          <span
            class="text-12 font-600 leading-17"
            @click="$emit('itemClick', { reasonContent: item })"
          >
            {{ item }}
          </span>
        </div>
      </li>
    </ul>
    <van-skeleton v-else>
      <template #template>
        <div
          class="w-full flex flex-col gap-10 [&>.van-skeleton-paragraph]:w-full [&>.van-skeleton-paragraph]:h-40! [&>.van-skeleton-paragraph]:rounded-8"
        >
          <van-skeleton-paragraph />
          <van-skeleton-paragraph />
          <van-skeleton-paragraph />
          <van-skeleton-paragraph />
          <van-skeleton-paragraph />
        </div>
      </template>
    </van-skeleton>
    <div
      class="text-12 text-#999 font-bold leading-14 pl-12 mt-20 mb-10"
      @click="$emit('refresh')"
    >
      {{ t("message.ai.Refresh") }} <van-icon name="replay" class="font-bold" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Message } from "./type";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps<{
  topics: string[];
}>();

defineEmits<{
  itemClick: [message: Partial<Message>];
  refresh: [];
}>();
</script>
